/**
 * Player/remote-view binding for the debug "macro running" indicator.
 *
 * Shows the blue flashing dot in the upper-left corner while the host reports
 * a macro is running (received over the player replication channel), but only
 * in debug (development) builds.
 */

import { useEffect, useState } from 'react';
import constants from '@playcastdotio/GlobalConfig';
import { MacroRunningIndicator } from '@playcastdotio/SharedComponents';
import { macroRunningState } from '../../api/stores/playerStores';

const isDebugMode = (): boolean => constants.ENVIRONMENT === 'development';

export const PlayerMacroRunningIndicator = () => {
  const [macroRunning, setMacroRunning] = useState(macroRunningState.currentState.macroRunning);

  useEffect(() => {
    setMacroRunning(macroRunningState.currentState.macroRunning);
    const listenerId = macroRunningState.addListener((state) => setMacroRunning(state.macroRunning));
    return () => macroRunningState.removeListener(listenerId);
  }, []);

  return <MacroRunningIndicator visible={isDebugMode() && macroRunning} />;
};
